import { Link, Navigate, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { ScreenTransition } from '@/components/ScreenTransition'
import { ProgressBar } from '@/components/ProgressBar'
import { HeightRow } from '@/components/HeightRow'
import { heightOptionsFor } from '@/data/heights'
import { HEIGHT_SCREEN_QUOTE } from '@/data/quotes'
import { useQuiz } from '@/state/QuizContext'
import { pingScreen } from '@/lib/ping'

/**
 * Screen 4 - Height. Single-select radio rows with Finish CTA.
 *
 * The cm cutoff between Short and Regular shifts based on activity (set on
 * Screen 1) - skiers and snow-play customers run regular from 5'3"+ while
 * snowboarders start at 5'2"+. We resolve the option list per-render rather
 * than caching, so going Back to change activity reflects in the bands here.
 */
export function HeightScreen() {
  const { activity, heightBand, setHeightBand, painPoints, bodyShape } = useQuiz()
  const navigate = useNavigate()

  useEffect(() => { pingScreen('height') }, [])

  if (!activity)                return <Navigate to="/questions/1" replace />
  if (painPoints.length === 0)  return <Navigate to="/questions/2" replace />
  if (!bodyShape)               return <Navigate to="/questions/3" replace />

  const options = heightOptionsFor(activity)
  const canFinish = heightBand !== null

  function handleFinish() {
    if (!canFinish) return
    navigate('/loading')
  }

  return (
    <ScreenTransition className="fq-question">
      <div className="fq-q-inner">
        <ProgressBar current={4} total={4} />

        <header className="fq-q-header">
          <p className="fq-eyebrow">Question 4 of 4</p>
          <h2 className="fq-h2">How tall are you?</h2>
          <p className="fq-lede">
            Pick whichever range your height falls into - we'll match you to
            the right inseam from there.
          </p>
        </header>

        <div
          className="fq-height-list"
          role="radiogroup"
          aria-label="Height band"
        >
          {options.map((option) => (
            <HeightRow
              key={option.id}
              option={option}
              selected={heightBand === option.id}
              onSelect={() => setHeightBand(option.id)}
            />
          ))}
        </div>

        <div className="fq-quote-row">
          <figure className="fq-quote">
            <blockquote>"{HEIGHT_SCREEN_QUOTE.text}" <span className="fq-quote-attr">- {HEIGHT_SCREEN_QUOTE.attribution}</span></blockquote>
          </figure>
          <div className="fq-actions">
            <Link to="/questions/3" className="fq-back">Back</Link>
            <button
              type="button"
              className="fq-cta"
              onClick={handleFinish}
              disabled={!canFinish}
            >
              See my match
            </button>
          </div>
        </div>
      </div>
    </ScreenTransition>
  )
}
